import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Row, Col, Table, Panel, PanelGroup } from "react-bootstrap";
import CustomModal from "../../components/Modal/CustomModal";

import { DataEstPendientes, ConsultaMaterias, ApruebaInsc, NoApruebaInsc } from '../../funciones/HeaderFunction';


class AcceptInscripcion extends Component {
    state = {
        boton1: {
            icon: "fa fa-times",
            text: "No Aprobar"
        },
        boton2: {
            icon: "fa fa-check",
            text: "Aprobar"
        },
        est: {
            nombre_1: "",
            nombre_2: "",
            apellido_1: "",
            apellido_1: "",
            id_estudiante: "",
            carrera_name: "",
            ci: "",
            nacionalidad: ""
        },
        btnDown: true,
        iconChevron: "fa fa-chevron-down",
        materiasIns: [],
        modalAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si"
        },
        modalNoAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si"
        },
        openAccept: this.props.isOpen,
        openNoAccept: this.props.isOpen,
        motivo: "",
        motivoIn: ""
    }

    constructor (props) {
        super (props);
        
        DataEstPendientes  (this.props.est, (resp) => {
            this.setState({
                est: resp[0]
            }, () => {
                ConsultaMaterias (this.state.est.email, (resp) => {
                    this.setState({
                        materiasIns: resp
                    })
                })
            })
        })
    }

    componentWillReceiveProps (props) {
        this.setState({
            openAccept: props.isOpen,
            openNoAccept: props.isOpen,
            motivo: "",
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:(event.target.value).toUpperCase(),
        });
    };

    contendidoEst = () => {
        let { est } = this.state;
        let nombre2 = "";
        let apellido2 = "";

        const estilos = {
            padding: 5, fontSize: 12
        };

        (est.nombre_2 === null) ? nombre2 = "" : nombre2 = est.nombre_2;
        (est.apellido_2 === null) ? apellido2 = "" : apellido2 = est.apellido_2;
        let { boton1, boton2 } = this.state;


        let contenidoMaterias = () => {
            let { materiasIns } = this.state;
            if (materiasIns.length === 0) {
                return (
                    <tr>
                        <td colSpan={5} align="center">No posee ninguna materia inscrita</td>
                    </tr>
                )
            }else{
                return (
                    materiasIns.map(option => (
                        <tr key = {option.id}>
                            <td style={estilos}>{option.materia}</td>
                            <td align="center" style={estilos}>{option.seccion}</td>
                            <td align="center" style={estilos}>{option.tipo}</td>
                            <td align="center" style={estilos}>{option.semestre}</td>
                            <td align="center" style={estilos}>{option.uc}</td>
                        </tr>
                    ))
                )
            }
        }

        return(
            <Row>
                <Col md={9} className="custom-mt-10">
                    <Col md={3} className="text-danger" style={{fontSize:10}}>
                        Cédula
                    </Col>
                    <Col md={5} className="text-danger" style={{fontSize:10}}>
                        Nombre y Apellido
                    </Col>
                    <Col md={4} className="text-danger" style={{fontSize:10}}>
                        Carrera
                    </Col>
                    <Col md={3} className="text-muted" style={{fontSize:10}}>
                        {`${est.nacionalidad} ${est.ci}`}
                    </Col>
                    <Col md={5} className="text-muted" style={{fontSize:10}}>
                        {`${est.nombre_1} ${nombre2} ${est.apellido_1} ${apellido2}`}
                    </Col>
                    <Col md={4} className="text-muted" style={{fontSize:10}}>
                        {est.carrera_name}
                    </Col>
                </Col>
                <Col md={3} align="right">
                    <div className="btn-group" style={{marginTop:10}}>
                        <button onClick={this.verModalNoAccept()} className="btn btn-danger" style={{borderWidth: 1}} title={boton1.text}><i className={boton1.icon}></i></button>
                        <button onClick={this.verModalAccept()} className="btn btn-primary" style={{borderWidth: 1}} title={boton2.text}><i className={boton2.icon}></i></button>
                    </div>
                </Col>
                <Col md={12} style={{padding:0}}><hr/></Col>
                <Col md={12}>
                    Materias Inscritas
                </Col>
                <Col md={12}>
                    <div className="table-responsive">
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="45%" style={estilos}><strong>Materia</strong></td>
                                    <td width="15%" align="center" style={estilos}><strong>Sección</strong></td>
                                    <td width="15%" align="center" style={estilos}><strong>Modalidad</strong></td>
                                    <td width="15%" align="center" style={estilos}><strong>Semestre</strong></td>
                                    <td width="10%" align="center" style={estilos}><strong>U.C.</strong></td>
                                </tr>
                                {contenidoMaterias()}
                            </tbody>
                        </Table>
                    </div>
                </Col>
                
            </Row>
        )
    }

    cambiaIcon = () => {
        this.setState ({
            btnDown: !this.state.btnDown,
            openAccept: false,
            openNoAccept: false,
        }, () => {
            (this.state.btnDown === true) ? this.setState({iconChevron: "fa fa-chevron-down"}) : this.setState({iconChevron: "fa fa-chevron-up"})
        })
    }

    verModalAccept = () => (e) => {
        this.setState({
            openAccept: true,
            openNoAccept: false, 
        })
    }

    verModalNoAccept = () => (e) => {
        this.setState({
            openNoAccept: true,
            openAccept: false, 
        })
    }

    modalAccept = () => {
        const { openAccept, modalAcceptBtn1, est } = this.state;

        let nombre2 = "";
        let apellido2 = "";
        (est.nombre_2 === null) ? nombre2 = "" : nombre2 = est.nombre_2;
        (est.apellido_2 === null) ? apellido2 = "" : apellido2 = est.apellido_2;

        let contenido = () => {
            return(
                <React.Fragment>
                    <div>¿Desea realmente <strong className="text-success">APROBAR</strong> la inscripción de <strong>{`${est.nombre_1} ${nombre2} ${est.apellido_1} ${apellido2}`}</strong>?</div>
                    <div style={{fontSize:12}}>Asegúrece de haber revisado <strong>Cuidadosamente</strong> las materias inscritas</div>
                </React.Fragment>
            )
        }

        let aceptar = (id) => (e) => {
            this.setState({
                modalAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espere"
                }
            })

            ApruebaInsc (id, (resp) => {
                this.setState ({
                    openAccept: false,
                    modalAcceptBtn1: {
                        icon:"fa fa-check",
                        text: "Si"
                    },
                },() => {
                    toast.info("Se ha inscrito correctamente el estudiante",{autoClose: 4000});
                    this.props.funcion()
                });
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalAcceptBtn1.icon}></i> {modalAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {aceptar(est.id_estudiante)}/>
        );
    }

    modalNoAccept = () => {
        const { openNoAccept, modalNoAcceptBtn1, motivo, motivoIn, est } = this.state;

        let nombre2 = "";
        let apellido2 = "";
        (est.nombre_2 === null) ? nombre2 = "" : nombre2 = est.nombre_2;
        (est.apellido_2 === null) ? apellido2 = "" : apellido2 = est.apellido_2;

        let contenido = () => {
            return(
                <React.Fragment>
                    <div>¿Desea realmente <strong className="text-danger"> NO APROBAR</strong> la inscripción de <strong>{`${est.nombre_1} ${nombre2} ${est.apellido_1} ${apellido2}`}</strong>?</div>
                    
                    <div className="custom-alert-danger" style={{padding:5}}>
                        <input type="text" value={motivo} onChange={this.cambiaValor("motivo")} className="form-control" placeholder="Indica el motivo"/>
                        <span className="text-danger">{motivoIn}</span>
                    </div>
                </React.Fragment>
            )
        }

        let noAceptar = (id) => (e) => {
            this.setState({
                modalNoAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espere"
                }
            })

            NoApruebaInsc (id, motivo, (resp) => {
                if (resp === false) {
                    this.setState({
                        motivoIn: "Indica primero el motivo"
                    })
                }else{
                    this.setState ({
                        openAccept: false,
                        modalNoAcceptBtn1: {
                            icon:"fa fa-check",
                            text: "Si"
                        },
                    },() => {
                        toast.info("Has rechazado la inscripción el estudiante",{autoClose: 4000});
                        this.props.funcion()
                    });
                }
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalNoAcceptBtn1.icon}></i> {modalNoAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openNoAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {noAceptar(est.id_estudiante)}/>
        );
    }

    render() {
        let { est, iconChevron } = this.state;
        return (
            <React.Fragment>
                <PanelGroup
                    accordion
                    activeKey={this.state.activeKey}
                    /* onSelect={this.cambiaPanel} */
                    className="custom-alert-info"
                >
                    <Panel eventKey={1}>
                        <Panel.Heading>
                            <Panel.Title toggle style={{color:"#1f2f6e"}} onClick={this.cambiaIcon}>
                                <Row>
                                    <Col md={10}>
                                        <div style={{fontSize: 11}}><strong>{`${est.nombre_1} ${est.apellido_1}`}</strong> <span style={{fontSize: 10}}>(Haz click aqui para ver las materias inscritas)</span></div>
                                    </Col>
                                    <Col md={2} align="right">
                                        <i className={iconChevron}></i>
                                    </Col>
                                </Row>
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible style={{paddingTop:10}}>
                            {this.contendidoEst()}
                        </Panel.Body>
                    </Panel>
                </PanelGroup>
                {this.modalAccept()}
                {this.modalNoAccept()}
            </React.Fragment>
        );
    }
}
 
export default AcceptInscripcion;


// WEBPACK FOOTER //
// ./src/views/Inscripcion/AcceptInscripcion.jsx